import { Search, Settings, ChevronRight, ChevronDown, Folder, FileCode, GitBranch } from 'lucide-react';

export default function SolutionExplorer({
  projectName = 'HelloWorld',
  filename = 'Program.cs',
  solExpanded = true,
  onToggle,
}) {
  return (
    <div className="w-[270px] flex-shrink-0 bg-[#252526] border-l border-[#333] flex flex-col">
      <div className="flex items-center justify-between h-[30px] px-3 bg-[#2d2d30] border-b border-[#333] flex-shrink-0">
        <span className="text-[11px] font-semibold text-[#ccc] uppercase tracking-wide">Solution Explorer</span>
        <div className="flex gap-1">
          <div className="w-5 h-5 flex items-center justify-center rounded hover:bg-white/10 cursor-pointer text-[#858585] hover:text-[#ccc] text-[11px]">⊟</div>
          <div className="w-5 h-5 flex items-center justify-center rounded hover:bg-white/10 cursor-pointer text-[#858585] hover:text-[#ccc]"><Settings size={12}/></div>
        </div>
      </div>

      {/* Search box */}
      <div className="flex items-center gap-1.5 mx-2 my-1.5 px-2 h-[22px] bg-[#3c3c3c] border border-[#555] rounded-sm flex-shrink-0">
        <Search size={11} className="text-[#555]"/>
        <span className="text-[11px] text-[#444]">Search Solution Explorer (Ctrl+;)</span>
      </div>

      <div className="flex-1 overflow-y-auto text-[12px]">
        {/* Solution */}
        <div
          className="flex items-center gap-1 px-2 py-1 hover:bg-[#2a2d2e] cursor-pointer"
          onClick={onToggle}
        >
          {solExpanded ? <ChevronDown size={13} className="text-[#858585]"/> : <ChevronRight size={13} className="text-[#858585]"/>}
          <Folder size={13} className="text-[#DCB67A]"/>
          <span className="text-[11px] text-[#ccc]">Solution '{projectName}' (1 of 1 project)</span>
        </div>

        {solExpanded && (
          <div className="ml-3">
            <div className="flex items-center gap-1 px-2 py-1 bg-[#0e639c] cursor-pointer">
              <ChevronDown size={13} className="text-[#aaa]"/>
              <FileCode size={13} className="text-[#4EC9B0]"/>
              <span className="font-medium">{projectName}</span>
            </div>
            <div className="ml-3">
              <div className="flex items-center gap-1 px-2 py-1 hover:bg-[#2a2d2e] cursor-pointer">
                <ChevronRight size={13} className="text-[#858585]"/>
                <Folder size={13} className="text-[#DCB67A]"/>
                <span className="text-[#999]">Dependencies</span>
              </div>
              <div className="flex items-center gap-1 px-2 py-1 bg-[#37373d] cursor-pointer">
                <span className="w-[13px]"/>
                <FileCode size={13} className="text-[#4EC9B0]"/>
                <span className="text-[#4EC9B0]">{filename}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Git status */}
      <div className="border-t border-[#333] px-3 py-2 flex items-center gap-2 text-[11px] text-[#666] flex-shrink-0">
        <GitBranch size={12}/>
        <span>main</span>
        <span className="ml-auto text-[#555]">↑0 ↓0</span>
      </div>
    </div>
  );
}
